.image {
    max-width: 640px; /* Match max width of the integration form below */
    object-fit: contain;
}

.list-style {
    max-width: 512px;
}
